import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-left.svg";
import * as styles from "./Icon.module.scss";

type ArrowLeftProps = React.SVGProps<SVGSVGElement>;

export const ArrowLeft = ({ className, ...props }: ArrowLeftProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
